module.exports = __webpack_public_path__ + "static/img/home_tzjsmfw_zydj.a7b706f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_tzjsmfw_zydj.png
// module id = P11F
// module chunks = 21